module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.160ff15c.svg";